require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-yoga-do-not-tuck.json") })
        }
      }, "path---blog-yoga-do-not-tuck");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-yoga-do-not-tuck!./.cache/json/blog-yoga-do-not-tuck.json
// module id = 314
// module chunks = 231608221292675